/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1MetricsGranularity } from '../models/V1MetricsGranularity';
import { V1ReportGranularity } from '../models/V1ReportGranularity';
import { HttpFile } from '../http/http';

/**
* CsvExportConfig holds settings that apply when export_type = CSV.
*/
export class V1CsvExportConfig {
    'metricsGranularity'?: V1MetricsGranularity;
    'reportGranularity'?: V1ReportGranularity;
    /**
    * Column names to include. Required (non-empty). Field applicability depends on report_granularity and metrics_granularity.
    */
    'fields': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metricsGranularity",
            "baseName": "metrics_granularity",
            "type": "V1MetricsGranularity",
            "format": ""
        },
        {
            "name": "reportGranularity",
            "baseName": "report_granularity",
            "type": "V1ReportGranularity",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CsvExportConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

